import { Button, Title } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { Popup } from "../Popup";
import { ScrollFadeIndicator } from "../ScrollFadeIndicator";
import { TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { solidFill } from "./NotificationBellIcon";
import { useNovuInbox } from "./NovuInboxProvider";
import "./NotificationsDrawer.css";
import { CloseLight } from "../../assets/navIcons";

export function NotificationsDrawer() {
  const inbox = useNovuInbox();
  const { t, i18n } = useTranslation();
  const { background, backgroundBtn, textColorBtn, bodyCopy } = useStore().theme.whiteView;
  const actionColor = solidFill(backgroundBtn);
  if (!inbox?.open) return null;

  return (
    <Popup
      visible={inbox.open}
      onClose={() => inbox.setOpen(false)}
      showClose={false}
      style={{ background }}
    >
      <section
        className="notifications-sheet"
        role="dialog"
        aria-label={t("notifications.title")}
      >
        <header className="payout-details-header">
          <span className="payout-header-action" aria-hidden="true" />
          <Title
            title={t("notifications.title")}
            align="center"
            color={bodyCopy}
          />
          <button
            type="button"
            className="payout-header-action payout-close-btn"
            aria-label={t("notifications.close")}
            onClick={() => inbox.setOpen(false)}
          >
            <CloseLight size={36} colors={[bodyCopy, bodyCopy]} />
          </button>
        </header>
        {inbox.items.length === 0 ? (
          <p className="notifications-sheet-empty" style={{ color: bodyCopy }}>
            {t("notifications.empty")}
          </p>
        ) : (
          <ul className="notifications-sheet-list">
            <ScrollFadeIndicator color={bodyCopy} />
            {inbox.items.map((item) => (
              <li key={item.id} data-read={item.isRead}>
                <span className="notifications-sheet-title">
                  {!item.isRead ? (
                    <span
                      className="notifications-sheet-dot"
                      style={{ background: backgroundBtn }}
                      aria-hidden="true"
                    />
                  ) : null}
                  <strong style={{ color: TITLE_COLOR }}>{item.title}</strong>
                </span>
                {item.body ? (
                  <p style={{ color: bodyCopy }}>{item.body}</p>
                ) : null}
                {item.createdAt ? (
                  <time
                    className="notifications-sheet-date"
                    dateTime={item.createdAt}
                    style={{ color: bodyCopy }}
                  >
                    {formatNoticeDate(item.createdAt, i18n.language)}
                  </time>
                ) : null}
                <div className="notifications-sheet-actions">
                  {!item.isRead ? (
                    <button
                      type="button"
                      style={{ color: actionColor }}
                      onClick={() => void inbox.markRead(item.id)}
                    >
                      {t("notifications.markRead")}
                    </button>
                  ) : null}
                  <button
                    type="button"
                    style={{ color: actionColor }}
                    onClick={() => void inbox.archive(item.id)}
                  >
                    {t("notifications.archive")}
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
        <p className="notifications-sheet-foot" style={{ color: bodyCopy }}>
          {t("notifications.retention")}
        </p>
        <Button
          size="small"
          background={backgroundBtn}
          color={textColorBtn}
          className="notifications-pref-button"
          onClick={() => inbox.openPreferences()}
        >
          {t("notifications.preferences")}
        </Button>
      </section>
    </Popup>
  );
}

function formatNoticeDate(iso: string, language: string): string {
  return new Intl.DateTimeFormat(language, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(iso));
}
